import {
    FETCH_TRANSACTION_HISTORY_REQUEST,
    FETCH_TRANSACTION_HISTORY_SUCCESS,
    FETCH_TRANSACTION_HISTORY_FAILURE,
  } from "../actions/TranscationHistoryType";
  
  import { getTransactionHistoryService } from "../../services/TranscationHIstoryService";
  

  export const fetchTransactionHistory = (patient_id) => async (dispatch) => {
    dispatch({ type: FETCH_TRANSACTION_HISTORY_REQUEST });
  
    try {
      const data = await getTransactionHistoryService(patient_id);
      dispatch({
        type: FETCH_TRANSACTION_HISTORY_SUCCESS,
        payload: data.data, // ✅ Use correct response key
      });
    } catch (error) {
      dispatch({
        type: FETCH_TRANSACTION_HISTORY_FAILURE,
        payload: error?.response?.data?.message || error.message,
      });
    }
  };